import axiosConfig from "./axiosConfig";
import { LeadCandidate } from "./postLeadSearch";

export interface VoaRefetchResponse {
  candidate: LeadCandidate;
}

const postVoaRefetch = async (
  authToken: string,
  sourceRef: string
): Promise<VoaRefetchResponse> => {
  const { data } = await axiosConfig.post(
    `/leads/voa/${encodeURIComponent(sourceRef)}/refetch`,
    {},
    { headers: { Authorization: `Bearer ${authToken}` } }
  );
  return data;
};

export default postVoaRefetch;
